import React from 'react';

const Blogs = () => {
    return (
        <div>
        <h3>কনটেক্সট এপিআই   কী? </h3>
        <p>
        রিঅ্যাক্ট কনটেক্সট এপিআই হল একটি রিঅ্যাক্ট অ্যাপের জন্য কার্যকরভাবে গ্লোবাল ভেরিয়েবল তৈরি করার <br/> একটি উপায় যা চারপাশে পাস করা যেতে পারে। <br/>
        এটি "প্রপ ড্রিলিং" বা দাদা-দাদি থেকে শিশু থেকে পিতা-মাতার কাছে প্রপস সরানোর বিকল্প। <br/>
        কনটেক্সট এপিআই   ট্রি ছাড়াই ডেটা পাস করার একটি উপায় প্রদান করে
        প্রতিটি স্তরে ম্যানুয়ালি পাস করতে হচ্ছে.

        </p>
        
         <h3> sementic tag  কী     </h3>
   
  Sementicএইচটিএমএল ট্যাগগুলি সেই ট্যাগের বিষয়বস্তু সম্পর্কে তথ্য প্রদান করে <br/> যা একটি পৃষ্ঠায় তারা যেভাবে দেখায় তার বাইরে যায়৷ <br/>      ট্যাগে আবদ্ধ পাঠ্যটি অবিলম্বে ব্রাউজার দ্বারা কিছু ধরণের কোডিং ভাষা হিসাবে স্বীকৃত হয়
         
    </div>
       

        
    );
};

export default Blogs;